import React, { useState, useRef } from 'react';
import Modal from 'react-modal';
import { Button } from 'react-bootstrap';
import { ArrowRightIcon } from '@primer/octicons-react';
import axios from 'axios';
import pocketLogo from '../assets/pocket-logo.svg';
import './ModalImport.css';

Modal.setAppElement('#root');

function ModalImport({ isOpen, onClose, collectionUuid }) {
    const [pocketAuthUrl, setPocketAuthUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const pocketAuthRef = useRef(null);

    const getPocketAuthUrl = () => {
        setIsLoading(true);

        const path = '/api/import/pocket';
        const params = {
            redirect_uri: window.location.origin + "/import/pocket/" + collectionUuid,
            collection_uuid: collectionUuid
        };

        axios.get(path, { params })
            .then((res) => {
                if (res.data.status === 'success') {
                    setPocketAuthUrl(res.data.auth_url);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="modal-content"
            overlayClassName="modal-overlay"
        >
            <div className="container">
                <div className="formGroup">
                    <div className="row formTitle">Import bookmarks</div>
                    <div className="row formField">
                        <div
                            className={`col button has-addons ${isLoading ? 'is-loading' : ''}`}
                            onClick={getPocketAuthUrl}
                            ref={pocketAuthRef}
                        >
                            <span className="icon is-small">
                                <img src={pocketLogo} alt="Pocket" />
                            </span>
                            <span>Import from Pocket</span>
                        </div>
                        {pocketAuthUrl && (
                            <a
                                className="col button is-info"
                                href={pocketAuthUrl}
                            >
                                <span>Authorize on Pocket</span>
                                <span className="icon is-small">
                                    <ArrowRightIcon size={16} />
                                </span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ModalImport;
